import React,{useState} from 'react';
import style from '../../css/ActivityBuilderContainer.module.css';
import {Grid, Typography, TextField, Card, CardActionArea, CardMedia, Box, Paper, Stack, IconButton, Alert, InputAdornment, Avatar, Button, ToggleButtonGroup, ToggleButton} from '@mui/material';
import {AddAPhoto,Add,DeleteRounded,ClearRounded} from '@mui/icons-material';
import {writeData, saveImage} from '../utils/datautils';
import { Section, WordTransform } from '../utils/other';
import { useDispatch, useSelector } from 'react-redux';
import { data, setData } from '../../storeredux';

export default function ActivityBuilderContainer(props) {
  const {setError,setResponse} = props
  const dataAll = useSelector(data)
  const dispatch = useDispatch()
  const {format} = require('date-fns');
  
  const[imgActivity, setImgActivity]=useState();
  const[listImgActivity,setListImgActivity]=useState([])
  const[imgPreviewActivity, setImgPreviewActivity]=useState('');
  const[listImgPreviewActivity, setListImgPreviewActivity]=useState([]);
  
  const[imgAchievement, setImgAchievement]=useState();
  const[listImgAchievement,setListImgAchievement]=useState([])
  const[imgPreviewAchievement, setImgPreviewAchievement]=useState('');
  const[listImgPreviewAchievement, setListImgPreviewAchievement]=useState([]);
  
  const[imgStaff, setImgStaff]=useState();
  const[imgPreviewStaff, setImgPreviewStaff]=useState('');
  const[imgAlumni, setImgAlumni]=useState();
  const[imgPreviewAlumni, setImgPreviewAlumni]=useState('');
  
  const[imgActivity2d, setImgActivity2d]=useState([]);
  const[imgActivityPreview2d, setImgActivityPreview2d]=useState([]);
  const[imgAchievement2d, setImgAchievement2d]=useState([]);
  const[imgAchievementPreview2d, setImgAchievementPreview2d]=useState([]);
  const[listImgStaff,setListImgStaff]=useState([])
  const[listImgPreviewStaff, setListImgPreviewStaff]=useState([]);
  const[listImgAlumni,setListImgAlumni]=useState([])
  const[listImgPreviewAlumni, setListImgPreviewAlumni]=useState([]);

  const staffNull = {
    'image':'',
    'name':'',
    'tahun':new Date().getFullYear(),
    'departemen':'',
    'jabatan':'',
    'motivasi':'',
    'facebook':'',
    'instagram':''
  };
  const alumniNull = {
    'image':'',
    'name':'',
    'tahun':0,
    'departemen':'',
    'jabatan':'',
    'motivasi':'',
    'facebook':'',
    'instagram':''
  };
  const activityNull = {
    'images':[],
    'title':'',
    'descTitle':'',
    'descMain':'',
    'rilis':''
  };
  const achievementNull = {
    'images':[],
    'title':'',
    'descMain':'',
    'tanggal':''
  };
  const[visi,setVisi]=useState('');
  const[misi,setMisi]=useState('');
  const[staff,setStaff]=useState(staffNull);
  const[alumni,setAlumni]=useState(alumniNull);
  const[activity,setActivity]=useState(activityNull);
  const[achievement,setAchievement]=useState(achievementNull);

  const[stateBtn,setStateBtn]=useState(0)

  const handleChange = (e) => {
    setImgActivity(e.target.files[0]);
    setImgPreviewActivity(URL.createObjectURL(e.target.files[0]))
  };

  const handleChange2 = (e) => {
    setImgAchievement(e.target.files[0]);
    setImgPreviewAchievement(URL.createObjectURL(e.target.files[0]))
  };

  const handleChange3 = (e) => {
    setImgStaff(e.target.files[0]);
    setImgPreviewStaff(URL.createObjectURL(e.target.files[0]))
  };

  const handleChange4 = (e) => {
    setImgAlumni(e.target.files[0]);
    setImgPreviewAlumni(URL.createObjectURL(e.target.files[0]))
  };

  const send = async () => {
    var dtbatch = {...dataAll}
    try {
      dtbatch['staff'] = await saveImage(dtbatch['staff'],listImgStaff)
      dtbatch['alumni'] = await saveImage(dtbatch['alumni'],listImgAlumni)
      dtbatch['activity'] = await saveImage(dtbatch['activity'],imgActivity2d)
      dtbatch['achievement'] = await saveImage(dtbatch['achievement'],imgAchievement2d)
      setResponse(await writeData(dtbatch)) 
    } catch(err) {
      setError(err.message)
    }
  }

  return(
    <Grid container spacing={2} className={style.root}>
      <Grid item xs={10}>
        <Section name="Visi Misi" align="left"/>
        <Paper>
          <Stack spacing={2} sx={{padding:'10px'}}>
            <TextField
              required
              type='text'
              label='Visi'
              variant='outlined'
              value={visi}
              onChange={(val) => {setVisi(val.currentTarget.value)}}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  <IconButton onClick={() => {dispatch(setData({...dataAll,'visi':[visi,...dataAll['visi']]}));setVisi('')}}><Add/></IconButton></InputAdornment>
              }}
            />
            <Stack spacing={2} sx={{overflow:'auto',maxHeight:'200px'}}>
              {
                dataAll['visi'].map((bg,i) => (
                  <Alert key={i} severity='success' action={
                    <Stack direction={'row'} spacing={1}>
                      <Button variant='contained' color='success' size="small" 
                        sx={{fontWeight:700}} onClick={() => {setVisi(bg);dispatch(setData({...dataAll,'visi':dataAll['visi'].filter(hg => hg !== bg)}))}}>
                        UPDATE
                      </Button>
                      <IconButton color='error' onClick={() => {dispatch(setData({...dataAll,'visi':dataAll['visi'].filter(hg => hg !== bg)}))}}>
                        <DeleteRounded/>
                      </IconButton>
                    </Stack>
                  }>
                    " {bg} " 
                  </Alert>
                ))
              }
            </Stack>
            <TextField
              required
              type='text'
              label='Misi'
              variant='outlined'
              value={misi.misi}
              onChange={(val) => {setMisi(val.currentTarget.value)}}
              InputProps={{
                endAdornment: <InputAdornment position="end">
                  <IconButton onClick={() => {dispatch(setData({...dataAll,'misi':[misi,...dataAll['misi']]}));setMisi('')}}><Add/></IconButton></InputAdornment>
              }}
            />
            <Stack spacing={2} sx={{overflow:'auto',maxHeight:'200px'}}>
              {
                dataAll['misi'].map((bg,i) => (
                  <Alert key={i} severity='success' action={
                    <Stack direction={'row'} spacing={1}>
                      <Button variant='contained' color='success' size="small" 
                        sx={{fontWeight:700}} onClick={() => {setMisi(bg);dispatch(setData({...dataAll,'misi':dataAll['misi'].filter(hg => hg !== bg)}))}}>
                        UPDATE
                      </Button>
                      <IconButton color='error' onClick={() => {dispatch(setData({...dataAll,'misi':dataAll['misi'].filter(hg => hg !== bg)}))}}>
                        <DeleteRounded/>
                      </IconButton>
                    </Stack>
                  }>
                    " {bg} " 
                  </Alert>
                ))
              }
            </Stack>
          </Stack>
        </Paper>
      </Grid>
      <Grid item xs={10}>
        <Section name="Add Activity" align="right"/>
        <Grid container>
          <Grid item xs={12} md={9}>
            <Stack spacing={2}>
              <TextField
                required
                type='text'
                label='Judul Aktivitas'
                variant='outlined'
                value={activity.title}
                onChange={(val) => {setActivity({...activity,'title':val.currentTarget.value})}}
              />
              <TextField
                required
                type='text'
                label='Sub Judul'
                variant='outlined'
                value={activity.descTitle}
                onChange={(val) => {setActivity({...activity,'descTitle':val.currentTarget.value})}}
              />
              <TextField
                required
                type='date'
                label='Tanggal Rilis'
                variant='outlined'
                value={activity.rilis}
                onChange={(val) => {setActivity({...activity,'rilis':val.currentTarget.value})}}
              />
              <Paper>
                <Stack sx={{padding:'10px'}}>
                  <TextField
                    required
                    multiline
                    minRows={3}
                    type='text'
                    label='Deskripsi'
                    variant='outlined'
                    value={activity.descMain}
                    sx={{width:'100%'}}
                    helperText="Using '@p' to create paragraph,@b...b@ for bold,@i...i@ for italics,@u...u@ for underline,@ll...ll@ for list and @l...l@ for list items(example: @ll @l ... l@@l ... l@ ll@), and @link ... link@[ ... ] for link url (example: @linkhttps://ums.comlink@[click here])"
                    onChange={(val) => {setActivity({...activity,'descMain':val.currentTarget.value})}}
                  />
                  <Typography variant='h4'>Preview</Typography>
                  <Paper sx={{wordWrap:'break-word',overflowWrap:'break-word'}}>
                    {(activity.descMain.length > 0)? WordTransform.getTransform(activity.descMain,'black'):null}
                  </Paper>
                </Stack>
              </Paper>
            </Stack>
          </Grid>
          <Grid item xs={12} md={3}>
            <Stack spacing={2} sx={{padding:'10px',justifyContent:'center',alignItems:'center',width:'100%'}}>
              <Typography variant='h6' style={{textAlign:'center', marginTop:'20px',fontWeight:300}}>
                Masukkan Gambar :
              </Typography>
              <Box justifyContent='center' alignItems='center' display='flex' width={'100%'}>
                <Card style={{width:'200px',height:'200px'}}>
                  <input
                    type="file"
                    accept="image/*"
                    id="imageparser1"
                    className="form-control"
                    onChange={ev => {handleChange(ev)}}
                    style={{display:'none'}}
                  />
                  <label htmlFor="imageparser1">
                    <CardActionArea component='span'>
                      <CardMedia image={imgPreviewActivity} title="foto">
                        <Box justifyContent='center' alignItems='center' display='flex' style={{height:'200px'}}>
                          <AddAPhoto color='primary'/>
                        </Box>
                      </CardMedia>
                    </CardActionArea>
                  </label>
                </Card>
              </Box>
              <Stack>
                <Button onClick={() => {
                  setListImgActivity([...listImgActivity,imgActivity]);setImgActivity(undefined);
                  setListImgPreviewActivity([...listImgPreviewActivity,imgPreviewActivity]);setImgPreviewActivity('')
                }} variant='contained'>Add Image</Button>
                <Stack direction="row">
                  {
                    listImgPreviewActivity.map((dt,i) => (
                      <Box key={i} justifyContent='center' alignItems='center' display='flex'
                        sx={{width:'75px', height:'75px', background:'rgba(0,0,0,.3)',position:'relative',color:'red'}} 
                        onClick={() => {
                          setListImgActivity(listImgActivity.filter(file => file !== listImgActivity[i]));
                          setListImgPreviewActivity(listImgPreviewActivity.filter(file => file !== dt))
                        }}>
                        <Avatar src={dt} variant='square' sx={{ width:'75px', height:'75px'}}/>
                        <ClearRounded sx={{position:'absolute'}}/>
                      </Box>
                    ))
                  }
                </Stack>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={2} sx={{padding:'10px',justifyContent:'center',alignItems:'center',width:'100%'}}>
              <Button variant='contained' onClick={() => {
                setImgActivity2d([listImgActivity,...imgActivity2d])
                setImgActivityPreview2d([listImgPreviewActivity,...imgActivityPreview2d])
                dispatch(setData({...dataAll,'activity':[activity,...dataAll['activity']]}))
                setActivity(activityNull)
                setListImgPreviewActivity([])
                setListImgActivity([])
              }} startIcon={<Add/>}>add activity</Button>
            </Stack>
          </Grid>
        </Grid>
        <Stack spacing={2} sx={{overflow:'auto',maxHeight:'400px'}}>
          {
            dataAll['activity'].map((dt,i) => (
              <Paper key={i} sx={{background:'#3dff5a',border:'2px solid #1ceb3b',color:'#12521b'}}>
                <Stack sx={{padding:'10px'}}>
                  <Typography variant='h6' color={'inherit'}>
                    <strong>Judul:</strong> {dt.title}
                  </Typography>
                  <Typography variant='body1' color={'inherit'}>
                    <strong>Sub Judul:</strong> {dt.descTitle}
                  </Typography>
                  <Typography variant='body2' color={'inherit'}>
                    <strong>Rilis:</strong> {format(new Date(dt.rilis), 'dd/MM/yyyy')}
                  </Typography>
                  <Typography variant='body2' color={'inherit'}>
                    <strong>Deskripsi:</strong>
                  </Typography>
                  <Box sx={{width:'100%',maxHeight:'100px',overflow:'auto',wordWrap:'break-word',overflowWrap:'break-word'}}>
                    {WordTransform.getTransform(dt.descMain,'black')}
                  </Box>
                  <Stack direction={'row'} spacing={1}>
                    <div style={{flexGrow:1}}/>
                    <Button variant='contained' color='success' size="small" 
                      sx={{fontWeight:700}} onClick={() => {
                        setActivity(dt)
                        if (imgActivity2d[i]) {
                          setListImgActivity(imgActivity2d[i])
                          setListImgPreviewActivity(imgActivityPreview2d[i])
                          setImgActivity2d(imgActivity2d.filter(hg => hg !== imgActivity2d[i]))
                          setImgActivityPreview2d(imgActivityPreview2d.filter(hg => hg !== imgActivityPreview2d[i]))
                        } 
                        dispatch(setData({...dataAll,'activity':dataAll['activity'].filter(hg => hg !== dt)}))
                      }}>
                      UPDATE
                    </Button>
                    <IconButton color='error' disabled={dt.images.length > 0} onClick={() => {
                      setImgActivity2d(imgActivity2d.filter(hg => hg !== imgActivity2d[i]))
                      setImgActivityPreview2d(imgActivityPreview2d.filter(hg => hg !== imgActivityPreview2d[i]))
                      dispatch(setData({...dataAll,'activity':dataAll['activity'].filter(hg => hg !== dt)}))
                    }}>
                      <DeleteRounded/>
                    </IconButton>
                  </Stack>
                </Stack>
              </Paper>
            ))
          }
        </Stack>
      </Grid>
      <Grid item xs={10}>
        <Section name="Add Staff & Alumni" align="left"/>
        <Stack justifyContent={'center'} alignItems={'center'}>
          <ToggleButtonGroup 
              color='secondary'
              variant="contained"
              value={stateBtn}
              exclusive
              onChange={(e,v) => {setStateBtn(v)}}
            >
            <ToggleButton value={0}>Staff</ToggleButton>
            <ToggleButton value={1}>Alumni</ToggleButton>
          </ToggleButtonGroup>
          <Paper sx={{width:'100%'}}>
            <Grid container sx={{display:`${(stateBtn === 0)?'flex':'none'}`,justifyContent:'center',alignItems:'center',padding:'10px'}} spacing={2}>
              <Grid item xs={12} md={9}>
                <Stack spacing={2}>
                  <TextField
                    required
                    type='text'
                    label='Nama'
                    variant='outlined'
                    value={staff.name}
                    onChange={(val) => {setStaff({...staff,'name':val.currentTarget.value})}}
                  />
                  <TextField
                    required
                    type='text'
                    label='Departemen'
                    variant='outlined'
                    value={staff.departemen}
                    onChange={(val) => {setStaff({...staff,'departemen':val.currentTarget.value})}}
                  />
                  <TextField
                    required
                    type='text'
                    label='Jabatan'
                    variant='outlined'
                    value={staff.jabatan}
                    onChange={(val) => {setStaff({...staff,'jabatan':val.currentTarget.value})}}
                  />
                  <TextField
                    required
                    type='text'
                    label='Motivasi'
                    variant='outlined'
                    value={staff.motivasi}
                    onChange={(val) => {setStaff({...staff,'motivasi':val.currentTarget.value})}}
                  />
                  <TextField
                    type='text'
                    label='Facebook'
                    variant='outlined'
                    value={staff.facebook}
                    onChange={(val) => {setStaff({...staff,'facebook':val.currentTarget.value})}}
                  />
                  <TextField
                    type='text'
                    label='Instagram'
                    variant='outlined'
                    value={staff.instagram}
                    onChange={(val) => {setStaff({...staff,'instagram':val.currentTarget.value})}}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={3}>
                <Stack spacing={2} sx={{justifyContent:'center',alignItems:'center',width:'100%'}}>
                  <Typography variant='h6' style={{textAlign:'center', marginTop:'20px',fontWeight:300}}>
                    Masukkan Gambar :
                  </Typography>
                  <Box justifyContent='center' alignItems='center' display='flex' width={'100%'}>
                    <Card style={{width:'200px',height:'200px'}}>
                      <input
                        type="file"
                        accept="image/*"
                        id="imageparser3"
                        className="form-control"
                        onChange={ev => {handleChange3(ev)}}
                        style={{display:'none'}}
                      />
                      <label htmlFor="imageparser3">
                        <CardActionArea component='span'>
                          <CardMedia image={imgPreviewStaff} title="foto">
                            <Box justifyContent='center' alignItems='center' display='flex' style={{height:'200px'}}>
                              <AddAPhoto color='primary'/>
                            </Box>
                          </CardMedia>
                        </CardActionArea>
                      </label>
                    </Card>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack sx={{justifyContent:'center',alignItems:'center',width:'100%'}}>
                  <Button variant='contained' onClick={() => {
                    setListImgStaff([imgStaff,...listImgStaff])
                    setListImgPreviewStaff([imgPreviewStaff,...listImgPreviewStaff])
                    dispatch(setData({...dataAll,'staff':[staff,...dataAll['staff']]}))
                    setStaff(staffNull)
                    setImgStaff(undefined)
                    setImgPreviewStaff('')
                  }} startIcon={<Add/>}>add staff</Button>
                </Stack>
              </Grid>
              <Stack spacing={2} sx={{overflow:'auto',maxHeight:'400px',marginTop:'20px'}}>
                {
                  dataAll['staff'].map((dt,i) => (
                    <Paper key={i} sx={{background:'#3dff5a',border:'2px solid #1ceb3b',color:'#12521b'}}>
                      <Stack sx={{padding:'10px'}}>
                        <Typography variant='h6' color={'inherit'}>
                          <strong>Nama:</strong> {dt.name}
                        </Typography>
                        <Typography variant='body1' color={'inherit'}>
                          <strong>Departemen:</strong> {dt.departemen}
                        </Typography>
                        <Typography variant='body1' color={'inherit'}>
                          <strong>Jabatan:</strong> {dt.jabatan}
                        </Typography>
                        <Typography variant='body2' color={'inherit'}>
                          <strong>Motivasi:</strong> " {dt.motivasi} "
                        </Typography>
                        {
                          (dt.facebook)? 
                            <Typography variant='body1' color={'inherit'}>
                              <strong>Facebook:</strong> {dt.facebook}
                            </Typography>:<></>
                        }
                        {
                          (dt.instagram)?
                            <Typography variant='body1' color={'inherit'}>
                              <strong>Instagram:</strong> {dt.instagram}
                            </Typography>:<></>
                        }
                        <Stack direction={'row'} spacing={1}>
                          <div style={{flexGrow:1}}/>
                          <Button variant='contained' color='success' size="small" 
                            sx={{fontWeight:700}} onClick={() => {
                              setStaff(dt)
                              if (listImgStaff[i]) {
                                setImgStaff(listImgStaff[i])
                                setImgPreviewStaff(listImgPreviewStaff[i])
                                setListImgStaff(listImgStaff.filter(hg => hg !== listImgStaff[i]))
                                setListImgPreviewStaff(listImgPreviewStaff.filter(hg => hg !== listImgPreviewStaff[i]))
                              }
                              dispatch(setData({...dataAll,'staff':dataAll['staff'].filter(hg => hg !== dt)}))
                            }}>
                            UPDATE
                          </Button>
                          <IconButton color='error' disabled={dt.image} onClick={() => {
                            setListImgStaff(listImgStaff.filter(hg => hg !== listImgStaff[i]))
                            setListImgPreviewStaff(listImgPreviewStaff.filter(hg => hg !== listImgPreviewStaff[i]))
                            dispatch(setData({...dataAll,'staff':dataAll['staff'].filter(hg => hg !== dt)}))
                          }}>
                            <DeleteRounded/>
                          </IconButton>
                        </Stack>
                      </Stack>
                    </Paper>
                  ))
                }
              </Stack>
            </Grid>
            <Grid container sx={{display:`${(stateBtn === 1)?'flex':'none'}`,justifyContent:'center',alignItems:'center',padding:'10px'}} spacing={2}>
              <Grid item xs={12} md={9}>
                <Stack spacing={2}>
                  <TextField
                    required
                    type='text'
                    label='Nama'
                    variant='outlined'
                    value={alumni.name}
                    onChange={(val) => {setAlumni({...alumni,'name':val.currentTarget.value})}}
                  />
                  <TextField
                    required
                    type='text'
                    label='Departemen'
                    variant='outlined'
                    value={alumni.departemen}
                    onChange={(val) => {setAlumni({...alumni,'departemen':val.currentTarget.value})}}
                  />
                  <TextField
                    required
                    type='text'
                    label='Jabatan'
                    variant='outlined'
                    value={alumni.jabatan}
                    onChange={(val) => {setAlumni({...alumni,'jabatan':val.currentTarget.value})}}
                  />
                  <TextField
                    required
                    type='number'
                    label='Tahun'
                    variant='outlined'
                    value={alumni.tahun}
                    onChange={(val) => {setAlumni({...alumni,'tahun':val.currentTarget.value})}}
                  />
                  <TextField
                    required
                    type='text'
                    label='Motivasi'
                    variant='outlined'
                    value={alumni.motivasi}
                    onChange={(val) => {setAlumni({...alumni,'motivasi':val.currentTarget.value})}}
                  />
                  <TextField
                    type='text'
                    label='Facebook'
                    variant='outlined'
                    value={alumni.facebook}
                    onChange={(val) => {setAlumni({...alumni,'facebook':val.currentTarget.value})}}
                  />
                  <TextField
                    type='text'
                    label='Instagram'
                    variant='outlined'
                    value={alumni.instagram}
                    onChange={(val) => {setAlumni({...alumni,'instagram':val.currentTarget.value})}}
                  />
                </Stack>
              </Grid>
              <Grid item xs={12} md={3}>
                <Stack spacing={2} sx={{justifyContent:'center',alignItems:'center',width:'100%'}}>
                  <Typography variant='h6' style={{textAlign:'center', marginTop:'20px',fontWeight:300}}>
                    Masukkan Gambar :
                  </Typography>
                  <Box justifyContent='center' alignItems='center' display='flex' width={'100%'}>
                    <Card style={{width:'200px',height:'200px'}}>
                      <input
                        type="file"
                        accept="image/*"
                        id="imageparser4"
                        className="form-control"
                        onChange={ev => {handleChange4(ev)}}
                        style={{display:'none'}}
                      />
                      <label htmlFor="imageparser4">
                        <CardActionArea component='span'>
                          <CardMedia image={imgPreviewAlumni} title="foto">
                            <Box justifyContent='center' alignItems='center' display='flex' style={{height:'200px'}}>
                              <AddAPhoto color='primary'/>
                            </Box>
                          </CardMedia>
                        </CardActionArea>
                      </label>
                    </Card>
                  </Box>
                </Stack>
              </Grid>
              <Grid item xs={12}>
                <Stack sx={{justifyContent:'center',alignItems:'center',width:'100%'}}>
                  <Button variant='contained' onClick={() => {
                    setListImgAlumni([imgAlumni,...listImgAlumni])
                    setListImgPreviewAlumni([imgPreviewAlumni,...listImgPreviewAlumni])
                    dispatch(setData({...dataAll,'alumni':[alumni,...dataAll['alumni']]}))
                    setAlumni(alumniNull)
                    setImgAlumni(undefined)
                    setImgPreviewAlumni('')
                  }} startIcon={<Add/>}>add alumni</Button>
                </Stack>
              </Grid>
              <Stack spacing={2} sx={{overflow:'auto',maxHeight:'400px',marginTop:'20px'}}>
                {
                  dataAll['alumni'].map((dt,i) => (
                    <Paper key={i} sx={{background:'#3dff5a',border:'2px solid #1ceb3b',color:'#12521b'}}>
                      <Stack sx={{padding:'10px'}}>
                        <Typography variant='h6' color={'inherit'}>
                          <strong>Nama:</strong> {dt.name}
                        </Typography>
                        <Typography variant='body1' color={'inherit'}>
                          <strong>Departemen:</strong> {dt.departemen}
                        </Typography>
                        <Typography variant='body1' color={'inherit'}>
                          <strong>Jabatan:</strong> {dt.jabatan}
                        </Typography>
                        <Typography variant='body1' color={'inherit'}>
                          <strong>Tahun:</strong> {dt.tahun}
                        </Typography>
                        <Typography variant='body2' color={'inherit'}>
                          <strong>Motivasi:</strong> " {dt.motivasi} "
                        </Typography>
                        {
                          (dt.facebook)? 
                            <Typography variant='body1' color={'inherit'}>
                              <strong>Facebook:</strong> {dt.facebook}
                            </Typography>:<></>
                        }
                        {
                          (dt.instagram)?
                            <Typography variant='body1' color={'inherit'}>
                              <strong>Instagram:</strong> {dt.instagram}
                            </Typography>:<></>
                        }
                        <Stack direction={'row'} spacing={1}>
                          <div style={{flexGrow:1}}/>
                          <Button variant='contained' color='success' size="small" 
                            sx={{fontWeight:700}} onClick={() => {
                              setAlumni(dt)
                              if (listImgAlumni[i]) {
                                setImgAlumni(listImgAlumni[i])
                                setImgPreviewAlumni(listImgPreviewAlumni[i])
                                setListImgAlumni(listImgAlumni.filter(hg => hg !== listImgAlumni[i]))
                                setListImgPreviewAlumni(listImgPreviewAlumni.filter(hg => hg !== listImgPreviewAlumni[i]))
                              }
                              dispatch(setData({...dataAll,'alumni':dataAll['alumni'].filter(hg => hg !== dt)}))
                            }}>
                            UPDATE
                          </Button>
                          <IconButton color='error' disabled={dt.image} onClick={() => {
                            setListImgAlumni(listImgAlumni.filter(hg => hg !== listImgAlumni[i]))
                            setListImgPreviewAlumni(listImgPreviewAlumni.filter(hg => hg !== listImgPreviewAlumni[i]))
                            dispatch(setData({...dataAll,'alumni':dataAll['alumni'].filter(hg => hg !== dt)}))
                          }}>
                            <DeleteRounded/>
                          </IconButton>
                        </Stack>
                      </Stack>
                    </Paper>
                  ))
                }
              </Stack>
            </Grid>
          </Paper>
        </Stack>
      </Grid>
      <Grid item xs={10}>
        <Section name="Add Achievement" align="right"/>
        <Grid container>
          <Grid item xs={12} md={9}>
            <Stack spacing={2}>
              <TextField
                required
                type='text'
                label='Judul'
                variant='outlined'
                value={achievement.title}
                onChange={(val) => {setAchievement({...achievement,'title':val.currentTarget.value})}}
              />
              <TextField
                required
                type='date'
                label='Tanggal'
                variant='outlined'
                value={achievement.tanggal}
                onChange={(val) => {setAchievement({...achievement,'tanggal':val.currentTarget.value})}}
              />
              <Paper>
                <Stack sx={{padding:'10px'}}>
                  <TextField
                    required
                    multiline
                    minRows={3}
                    type='text'
                    label='Deskripsi'
                    variant='outlined'
                    value={achievement.descMain}
                    sx={{width:'100%'}}
                    helperText="Using '@p' to create paragraph,@b...b@ for bold,@i...i@ for italics,@u...u@ for underline,@ll...ll@ for list and @l...l@ for list items(example: @ll @l ... l@@l ... l@ ll@), and @link ... link@[ ... ] for link url (example: @linkhttps://ums.comlink@[click here])"
                    onChange={(val) => {setAchievement({...achievement,'descMain':val.currentTarget.value})}}
                  />
                  <Typography variant='h4'>Preview</Typography>
                  <Paper sx={{wordWrap:'break-word',overflowWrap:'break-word'}}>
                    {(achievement.descMain.length > 0)? WordTransform.getTransform(achievement.descMain,'black'):null}
                  </Paper>
                </Stack>
              </Paper>
            </Stack>
          </Grid>
          <Grid item xs={12} md={3}>
            <Stack spacing={2} sx={{padding:'10px',justifyContent:'center',alignItems:'center',width:'100%'}}>
              <Typography variant='h6' style={{textAlign:'center', marginTop:'20px',fontWeight:300}}>
                Masukkan Gambar :
              </Typography>
              <Box justifyContent='center' alignItems='center' display='flex' width={'100%'}>
                <Card style={{width:'200px',height:'200px'}}>
                  <input
                    type="file"
                    accept="image/*"
                    id="imageparser2"
                    className="form-control"
                    onChange={ev => {handleChange2(ev)}}
                    style={{display:'none'}}
                  />
                  <label htmlFor="imageparser2">
                    <CardActionArea component='span'>
                      <CardMedia image={imgPreviewAchievement} title="foto">
                        <Box justifyContent='center' alignItems='center' display='flex' style={{height:'200px'}}>
                          <AddAPhoto color='primary'/>
                        </Box>
                      </CardMedia>
                    </CardActionArea>
                  </label>
                </Card>
              </Box>
              <Stack>
                <Button onClick={() => {
                  setListImgAchievement([...listImgAchievement,imgAchievement]);setImgAchievement(undefined);
                  setListImgPreviewAchievement([...listImgPreviewAchievement,imgPreviewAchievement]);setImgPreviewAchievement('')
                }} variant='contained'>Add Image</Button>
                <Stack direction="row">
                  {
                    listImgPreviewAchievement.map((dt,i) => (
                      <Box key={i} justifyContent='center' alignItems='center' display='flex'
                        sx={{width:'75px', height:'75px', background:'rgba(0,0,0,.3)',position:'relative',color:'red'}} 
                        onClick={() => {
                          setListImgActivity(listImgAchievement.filter(file => file !== listImgAchievement[i]));
                          setListImgPreviewActivity(listImgPreviewAchievement.filter(file => file !== dt))
                        }}>
                        <Avatar src={dt} variant='square' sx={{ width:'75px', height:'75px'}}/>
                        <ClearRounded sx={{position:'absolute'}}/>
                      </Box>
                    ))
                  }
                </Stack>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={2} sx={{padding:'10px',justifyContent:'center',alignItems:'center',width:'100%'}}>
              <Button variant='contained' onClick={() => {
                setImgAchievement2d([listImgAchievement,...imgAchievement2d])
                setImgAchievementPreview2d([listImgPreviewAchievement,...imgAchievementPreview2d])
                dispatch(setData({...dataAll,'achievement':[achievement,...dataAll['achievement']]}))
                setAchievement(achievementNull)
                setListImgPreviewAchievement([])
                setListImgAchievement([])
              }} startIcon={<Add/>}>add achievement</Button>
            </Stack>
          </Grid>
        </Grid>
        <Stack spacing={2} sx={{overflow:'auto',maxHeight:'400px'}}></Stack>
        {
          dataAll['achievement'].map((dt,i) => (
            <Paper key={i} sx={{background:'#3dff5a',border:'2px solid #1ceb3b',color:'#12521b'}}>
              <Stack sx={{padding:'10px'}}>
                <Typography variant='h6' color={'inherit'}>
                  <strong>Judul:</strong> {dt.title}
                </Typography>
                <Typography variant='body2' color={'inherit'}>
                  <strong>Tanggal:</strong> {format(new Date(dt.tanggal), 'dd/MM/yyyy')}
                </Typography>
                <Typography variant='body2' color={'inherit'}>
                  <strong>Deskripsi:</strong>
                </Typography>
                <Box sx={{width:'100%',maxHeight:'100px',overflow:'auto',wordWrap:'break-word',overflowWrap:'break-word'}}>
                  {WordTransform.getTransform(dt.descMain,'black')}
                </Box>
                <Stack direction={'row'} spacing={1}>
                  <div style={{flexGrow:1}}/>
                  <Button variant='contained' color='success' size="small" 
                    sx={{fontWeight:700}} onClick={() => {
                      setAchievement(dt)
                      if (imgAchievement2d[i]) {
                        setListImgAchievement(imgAchievement2d[i])
                        setListImgPreviewAchievement(imgAchievementPreview2d[i])
                        setImgAchievement2d(imgAchievement2d.filter(hg => hg !== imgAchievement2d[i]))
                        setImgAchievementPreview2d(imgAchievementPreview2d.filter(hg => hg !== imgAchievementPreview2d[i]))
                      }
                      dispatch(setData({...dataAll,'achievement':dataAll['achievement'].filter(hg => hg !== dt)}))
                    }}>
                    UPDATE
                  </Button>
                  <IconButton color='error' disabled={dt.images.length > 0} onClick={() => {
                    setImgAchievement2d(imgAchievement2d.filter(hg => hg !== imgAchievement2d[i]))
                    setImgAchievementPreview2d(imgAchievementPreview2d.filter(hg => hg !== imgAchievementPreview2d[i]))
                    dispatch(setData({...dataAll,'achievement':dataAll['achievement'].filter(hg => hg !== dt)}))
                  }}>
                    <DeleteRounded/>
                  </IconButton>
                </Stack>
              </Stack>
            </Paper>
          ))
        }
      </Grid>
      <Grid item xs={12} sx={{background:'#d9d9d9',marginTop:'50px'}}>
        <Stack direction={'row'}>
          <div style={{flexGrow:1}}/>
          <Button color='warning' variant='contained' sx={{margin:'10px',marginRight:'5%'}} onClick={() => {send()}}>Save</Button>
        </Stack>
      </Grid>
    </Grid>
  );
}
